import React from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import styles from './Styles/Footer.module.css';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Footer = () => {
  const { lang } = useParams();
  const { t, i18n } = useTranslation();
  // Change the language dynamically
  React.useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        {/* Left section: Navigation */}
        <div className={styles.navLinks}>
          <NavLink to={`/${lang}/comments`} className={styles.navLink}>{t('menu.kommentare')}</NavLink>
          <NavLink to={`/${lang}/impressum`} className={styles.navLink}>{t('menu.impressum')}</NavLink>
          <NavLink to={`/${lang}/datenschutz`} className={styles.navLink}>{t('menu.datenschutz')}</NavLink>
          <button className={styles.navLink} onClick={() => { window.UC_UI.showSecondLayer() } }>{t('menu.privacysettings')}</button>
          { (lang === "de") && <LanguageSwitcher newLang="en" className={styles.navLink} icon={"Change language to English"} /> }
          { (lang === "en") && <LanguageSwitcher newLang="de" className={styles.navLink} icon={"Auf Deutsch wechseln"} /> }
        </div>

        {/* Right section: Logo and copyright */}
        <div className={styles.logoAndCopyright}>
          <img
            src="/logo-frankgrosseworldlist-weiss.png"
            alt="Frank Grosse World List Logo"
            className={styles.logo}
          />
          <p className={styles.copyright}>
            &copy; {new Date().getFullYear()} Frank Grosse<br />
            Design by <Link target="_blank" rel="noopener noreferrer" to={`https://www.hilledesign.ch`} className={styles.textLink}>hilledesign</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
